import { MediaItem, TypeGuards } from '../models';
import { FormatChecker, HttpClient, JsonUtils } from '../utils';

export class ContentLoader {

    private static readonly http: HttpClient = new HttpClient();

    static async fetch(url: string): Promise<MediaItem[]> {
        if (FormatChecker.isJson(url)) {
            const json: string = (await ContentLoader.http.get(url)).body;
            let playlist: MediaItem[] | MediaItem = JsonUtils.Decode<MediaItem[] | MediaItem>(json);
            if (playlist === null) {
                throw {message: 'Invalid playlist format. Playlist must be a valid Json array'};
            }
            const isMediaPlaylist: boolean = TypeGuards.isMediaPlaylist(playlist);
            const isMediaItem: boolean = TypeGuards.isMediaItem(playlist);
            if (!isMediaPlaylist && !isMediaItem) {
                throw {message: 'Invalid playlist format. The JSON string is not a MediaItem nor a MediaItem array'};
            }
            // If it's a mediaItem
            if (isMediaItem) {
                playlist = [<MediaItem>playlist];
            }
            (<MediaItem[]>playlist).forEach((item: MediaItem) => item.contentId = item.mediaid);
            return <MediaItem[]>playlist;
        }
    }
}
